varying vec2 vUv; 
varying vec3 vPos;
varying vec3 vNormal; 
// 
uniform vec3 u_camPos;
uniform float u_powerShine;
uniform sampler2D u_noiseTexture;

#define PI 3.1415926538

uniform float u_time;

void main()
{


    vec2 ndc = (vUv -0.5)*2.;
    vec2 uv = vUv;
    float speed = 0.6;
    uv.x -= cos(uv.y*1.5);
    float noise = texture2D(u_noiseTexture, uv).r;

    
    // vec3 test = vec3(1., 0.4, 0.7);
    vec3 test = vec3(0.9137254901960784, 0.592156862745098, 0.5686274509803921);
    
    gl_FragColor = vec4(vUv, 1., 1.);
    gl_FragColor = vec4(test*(1.-noise)*0.3, 1.);
    // gl_FragColor = vec4(normal, 1.);
}